import {
  type ExternalActionRequest,
  ExternalActionRequestType
} from 'types/api/scenarios/scenario'

export enum NodeSectionType {
  ExternalActions = 'ExternalActions',
  ExternalRollbacks = 'ExternalRollbacks',
  Observers = 'Observers',
  Nodes = 'Nodes'
}

export const NODE_SECTION_MESSAGING = {
  [NodeSectionType.ExternalActions]: {
    label: 'External Steps',
    description:
      'Gremlin can automate some external steps for this Scenario. The external steps will be run in the order they are entered. Gremlin will automatically generate your rollback steps for these actions.'
  },
  [NodeSectionType.ExternalRollbacks]: {
    label: 'External Rollback Steps',
    description:
      'These steps are automatically generated if external steps are added.'
  },
  [NodeSectionType.Observers]: {
    label: 'Health Checks',
    description:
      'These Health Checks will be polled continuously during the entire Scenario.'
  },
  [NodeSectionType.Nodes]: {
    label: 'Gremlin Steps',
    description: 'These are the fault injection steps that Gremlin provides.'
  }
}

export function getExternalActionText(
  externalActionRequest: ExternalActionRequest
) {
  switch (externalActionRequest.type) {
    case ExternalActionRequestType.DisableAWSAutoScalingGroups:
      return 'Disable'
    case ExternalActionRequestType.RemoveAWSSecurityGroups:
      return 'Remove'
    default:
      return 'Re-enable'
  }
}

export function getExternalActionTargetPrefix(
  externalActionRequest: ExternalActionRequest,
  includeTransition = true
) {
  switch (externalActionRequest.type) {
    case ExternalActionRequestType.DisableAWSAutoScalingGroups:
      return `ASG autoscaling${includeTransition ? ' on' : ''}`
    default:
      return `Security Group${includeTransition ? ' from' : ''}`
  }
}
